import * as Utils from '../../utils/util';
import * as Toolkit from '../../toolkit/index';
import Config from '../../config/index';
import { __getPhysics__, __allCubeIds__, __getLogic__ } from './db';
import { __has__ } from './db';
import { logicToPaint } from '../transform';

// 物理坐标
export function getPhysicsCoordinate(cubeId: CubeId): PhysicsCoordinate|null {
    let temp: PhysicsCoordinate|null = __getPhysics__(cubeId);

    if (temp) {
        return Utils.deepCopy(temp);
    }

    return null;
}

// 逻辑坐标
export function getLogicCoordinate(cubeId: CubeId): LogicCoordinate|null {
    let temp: LogicCoordinate|null = __getLogic__(cubeId);

    if (temp) {
        return Utils.deepCopy(temp);
    }

    return null;
}

export function getAllLogicCoordinate(): Array<CubeLogicCoordinate> {
    let result: Array<CubeLogicCoordinate> = [];
    let cubeIds: Array<CubeId> = allCubeIds();

    cubeIds.forEach((cubeId: CubeId): void => {
        let logicCoordinate: LogicCoordinate|null = getLogicCoordinate(cubeId);

        logicCoordinate && result.push({
            ...logicCoordinate,
            id: cubeId
        });
    });

    return result;
}

export function getLogicCoordinates(cubeIds: Array<CubeId>): Array<LogicCoordinate> {
    let result: Array<LogicCoordinate> = [];

    cubeIds.forEach((cubeId: CubeId): void => {
        let temp: LogicCoordinate|null = getLogicCoordinate(cubeId);

        temp && result.push(temp);
    });

    return result;
}

// 获取渲染坐标，坐标原点为 div.shelvesbuild-e-sketchpad 左上角
export function getPaintCoordinate(cubeId: CubeId): PaintCoordinate {
    let logic: LogicCoordinate = getLogicCoordinate(cubeId);

    return logicToPaint(logic);
}

export function getPaintCoordinates(cubeIds: CubeId[]): CubePaintCoordinate[] {
    return cubeIds.map((cubeId: CubeId): CubePaintCoordinate => {
        let coordinate: PaintCoordinate = getPaintCoordinate(cubeId);

        return {
            ...coordinate,
            id: cubeId
        };
    });
}

export function has(cubeId: CubeId): boolean {
    return __has__(cubeId);
}

export function allCubeIds(): Array<CubeId> {
    return __allCubeIds__();
}
